module.exports = __webpack_public_path__ + "ce6728457ac0a90ad3bdf097f91b60de.png";